// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_1uUmV","modalControls":"_2xyun","deleteBtnWrapper":"_1lWwV"};